import { useNavigate, useLocation } from "react-router-dom";
import { useMixPanel } from "../../hooks/useMixPanel";

import { DataGridPro } from "@mui/x-data-grid-pro";

import { Box, Typography } from "@mui/material";

import "./ReferralTable.css";
import ReferralTableCellLeft from "./ReferralTableCellLeft";
import ReferralTableCellMid from "./ReferralTableCellMid";
import { T } from "../../hooks/useTranslate";

const ReferralTable = ({ referrals }) => {
  const location = useLocation();
  const { logEvent } = useMixPanel();

  const columns = [
    {
      headerName: "MEMBER",
      headerClassName: "referralTableHeader",
      sortable: false,
      width: 165,
      field: "name",
      headerAlign: "left",
      align: "left",
      renderCell: (params) => <ReferralTableCellLeft referral={params.row} />,
      renderHeader: () => <Typography sx={{ fontSize: "calc(10px * var(--unicity-font-scale, 1))" }}><T>member</T></Typography>,
    },
    {
      headerName: "SUBSCRIPTION",
      headerClassName: "referralTableHeader",
      sortable: false,
      width: 120,
      field: "subscription",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => <ReferralTableCellMid referral={params.row} />,
      renderHeader: () => <Typography sx={{ fontSize: "calc(10px * var(--unicity-font-scale, 1))" }}><T>subscription</T></Typography>,
    },
    {
      headerName: "ORDERS",
      headerClassName: "referralTableHeader",
      sortable: false,
      width: 60,
      field: "orders",
      headerAlign: "right",
      align: "right",
      renderHeader: () => <Typography sx={{ fontSize: "calc(10px * var(--unicity-font-scale, 1))" }}><T>orders</T></Typography>,
    },
  ];

  const navigate = useNavigate();
  const handleRowClick = (params) => {
    logEvent("open_profile", {
      user_type: "member",
      location: "referrals_summary_drawer"
    });
    navigate(`${location.pathname}?drawer=member&id=${params.row.unicityId}&drawerContent=profile`, { state: location });
  }

  return (
    <Box id="ReferralDataGrid" sx={{ flexGrow: 1 }}>
      <DataGridPro
        columns={columns}
        rows={referrals}
        disableColumnMenu
        disableRowSelectionOnClick
        disableVirtualization
        autoHeight
        hideFooter
        getRowId={(row) => row.unicityId}
        onRowClick={handleRowClick}
        sx={{
          fontSize: "calc(12px * var(--unicity-font-scale, 1))",
          border: "none",
        }}
      />
    </Box>
  );
};

export { ReferralTable };
